import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  // This SPA can only ever return HTTP 200, so Google was flagging every
  // unmatched URL as a "Soft 404". Emitting a noindex,follow robots tag tells
  // Google to drop these pages from the index instead of reporting them as
  // soft 404s. RouteSEO sets index,follow by default; this runs after and wins
  // for the catch-all route. Restored on unmount so real pages stay indexable.
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    const created = !el;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'robots');
      document.head.appendChild(el);
    }
    const prev = el.getAttribute('content');
    el.setAttribute('content', 'noindex, follow');
    return () => {
      if (created && el.parentNode) el.parentNode.removeChild(el);
      else if (prev != null) el.setAttribute('content', prev);
    };
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '40px 20px',
      background: 'var(--dark-purple)',
    }}>
      <h1 style={{
        fontSize: 'clamp(80px, 20vw, 160px)',
        fontWeight: '900',
        margin: 0,
        lineHeight: 1,
        background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}>
        404
      </h1>
      <h2 style={{ color: '#fff', fontSize: '1.5rem', margin: '16px 0 12px' }}>
        Page Not Found
      </h2>
      <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1rem', maxWidth: 400, marginBottom: 32 }}>
        The page you're looking for doesn't exist or you don't have permission to view it.
      </p>
      <Link
        to="/"
        style={{
          padding: '14px 32px',
          background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
          color: '#fff',
          textDecoration: 'none',
          borderRadius: '8px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: '0 4px 15px rgba(216,134,255,0.4)',
        }}
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
